import { createRouter, createWebHistory } from 'vue-router'
import Primaleva from '../views/Primalevaview.vue'

const routes = [
  {
    path: '/',
    name: 'primaleva',
    component: Primaleva
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
